export default "/images/df7260e4cc84237ac67f9f3c9bc7313f.avif";